/**
 * Surface of every floating overlay (dropdown menus, popovers, select lists, dialogs): the elevated fill, a 1px
 * strong rule, the 6px radius and the single overlay shadow.
 */
export const overlaySurfaceClasses =
  'z-50 rounded-md border border-border-strong bg-elevated text-text shadow-lg outline-none';

/** Scrim behind modal dialogs: a flat graphite layer with no blur. */
export const scrimClasses =
  'fixed inset-0 z-50 bg-scrim/45 data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out dark:bg-scrim/70';
